import React,{ Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { getPedidosAdmin } from '../actions'
import { getRubroCats } from "../actions/admin";
import AdminMenu from '../components/admin_menu'

class Admin extends Component{
	
	constructor(props) {
    	super(props);
    	this.state = {
        	loading : false
    	}
    }

  componentDidMount(){
    if(!this.props.usuario.user){
      this.props.history.push("/login")
    }
    if (this.props.productos.rubros.length<1){
      this.props.getRubroCats()
    }
  }

  componentDidUpdate(prevProps, prevState){

  }

  verPedido(){

  }

  limpiaCarro(){

  }

	render() {  

    return (
      <section className="row mb-5 sombraHead mt-3 clearfix" >
        <div className="col-md-4 mb-3">
        <AdminMenu />
        </div>

        <div className="col-md-6 mb-3">
          
        </div>

      </section>
    )
  }
}

const mapStateToProps = state => {
	return {
      usuario: state.usuario,
      productos:state.productos
  	}
}

const mapDispatchToProps = dispatch => {
  return {
    getRubroCats: () => {
      dispatch(getRubroCats())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Admin)




// WEBPACK FOOTER //
// ./src/containers/admin.js